'use strict';

import DataSource from './data-source/data-source';
import BiLoadPhaseDataItem from './data-items/bi-load-phase-item';
import DurationDataItem from './data-items/duration-item';
import BiErrorItem from './data-items/bi-error-item';
import performance from './performance/performance';
import ResourceDataItem from './data-items/resource-item';

/**
 * Base Logger
 *
 * Before adding new parameters to the reported events, please make sure the BI schema supports them:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72
 */
export default class BaseLogger {
  constructor(appName, appVersion, reporter, {sessionId, errorHandlerToggle, disableAutoLoadFinish}) {
    this.appName = appName;
    this.appVersion = appVersion;
    this.reporter = reporter;
    this.params = {sessionId};
    this.errorHandlerToggle = errorHandlerToggle;
    this.disableAutoLoadFinish = disableAutoLoadFinish;
    this.dataSource = new DataSource({appName});
    if (errorHandlerToggle) {
      window.fedopsLoggerErrorHandler.subscribeListener(appName, this.reportError.bind(this));
    }
  }

  reportNetworkAnalysis() {
    const resources = performance.getResources();
    setTimeout(() => {
      try {
        const resourceDataItem = new ResourceDataItem(this.sessionId);
        const analysis = resourceDataItem.performNetworkAnalysis(resources);
        if (!analysis) {
          return;
        }
        const dataSource = this.dataSource.clone()
          .addItem(resourceDataItem)
          .addItem(analysis);
        this._report(dataSource);
      } catch (e) {
        console.error('[fedops] Failed to report resource metrics', e);
      }
    }, 1000);
  }

  reportError(error, errorType, errorInfo) {
    let interactionName;

    if (!this._appLoadedCalled) {
      interactionName = '[APP LOAD]';
    } else {
      interactionName = Object.keys(this._outgoingInteractions)[0];
    }

    const dataSource = this.dataSource.clone()
      .addItem({interactionName})
      .addItem({errorType})
      .addItem({errorInfo})
      .addItem(new BiErrorItem(this.sessionId));

    // const stackTrace = error.stack;

    if (interactionName) {
      this._report(dataSource);
    }
  }

  _report(dataSource) {
    return this.reporter.report(dataSource.mergeItems());
  }

  getAppName() {
    return this.appName;
  }

  getAppVersion() {
    return this.appVersion;
  }

  getReporter() {
    return this.reporter;
  }

  getParam(paramName) {
    return this.params[paramName];
  }

  _isDisableAutoLoadFinish() {
    return this.disableAutoLoadFinish;
  }

  get sessionId() {
    return this.getParam('sessionId');
  }

  /**
   * Custom phase (http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/13)
   * Call this method to report custom phases during initial application load.
   *
   * @param {String} phaseName  phase name
   */
  appLoadingPhase(phaseName) {
    const dataSource = this.dataSource.clone()
      .addItem({name: phaseName})
      .addItem(new BiLoadPhaseDataItem(this.sessionId))
      .addItem(new DurationDataItem());

    return this._report(dataSource);
  }
}



// WEBPACK FOOTER //
// ./base-logger.js